"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useDidUpdateEffect = (effect, deps) => {
    const didMountRef = react_1.useRef(false);
    react_1.useEffect(() => {
        if (didMountRef.current) {
            effect();
        }
        else {
            didMountRef.current = true;
        }
    }, deps);
};
exports.default = useDidUpdateEffect;
